import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeFlightIcon = _ref => {
  let {
      size = "23",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    "clip-path": "url(#clip0_25809_57021)"
  }, __jsx("path", {
    d: "M28.5001 21.8332V19.1665L17.8334 12.4998V5.1665C17.8334 4.05984 16.9401 3.1665 15.8334 3.1665C14.7267 3.1665 13.8334 4.05984 13.8334 5.1665V12.4998L3.16675 19.1665V21.8332L13.8334 18.4998V25.8332L11.1667 27.8332V29.8332L15.8334 28.4998L20.5001 29.8332V27.8332L17.8334 25.8332V18.4998L28.5001 21.8332Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_25809_57021"
  }, __jsx("rect", {
    width: "32",
    height: "32",
    fill: "white",
    transform: "translate(0.5 0.5)"
  }))));
};
export default HomeFlightIcon;